export default __webpack_public_path__ + "static/media/grocery12.cd3fbe93.jpeg";